import { VIDEO_BACKGROUND_URL } from "../commons/enum";

const SignupBanner = () => {
  return (
    <div className="signup-banner">
      <video
        autoPlay
        loop
        muted
        playsInline
        src={VIDEO_BACKGROUND_URL}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default SignupBanner;
